var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"server-container"},[_c('h2',[_vm._v("服务器管理")]),_c('div',{staticClass:"content"},[_vm._v(" 这里是服务器管理页面的内容 ")])])
}]

export { render, staticRenderFns }